const WORDS = ["Good Student", "Student Away at School", "Driver Training", "Telematics", "Licensed in Georgia"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`px-8 font-display text-6xl font-black uppercase sm:text-8xl ${i % 2 ? "text-outline" : "text-bone"}`}>{w}</span>
        <span className="h-4 w-16 rounded-full bg-lane" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="overflow-hidden border-y border-white/10 bg-graphite py-10" data-testid="discount-marquee" aria-label="Discounts">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
